// extracted by mini-css-extract-plugin
export default {"emailImage":"CheckYourEmail_emailImage__ePRYh","contentWrapper":"CheckYourEmail_contentWrapper__i8ulb","linkButton":"CheckYourEmail_linkButton__pNnIj"};